import styled from 'styled-components'

type CalloutContentWrapperProps = {
  textAlign?: string
}

export const CalloutContentWrapper = styled.div<CalloutContentWrapperProps>`
  text-align: ${(props) => props.textAlign};
`
